import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  Grid
} from '@material-ui/core';
import { RefreshCw as RefreshIcon } from 'react-feather';

const SalesListToolbar = ({ dateFrom, setDateFrom, dateTo, setDateTo, onRefresh, ...props }) => (
  <Box {...props}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end'
      }}
    >
      <Button
        color="primary"
        variant="contained"
        startIcon={<RefreshIcon />}
        onClick={onRefresh}
      >
        Atualizar
      </Button>
    </Box>
    <Box sx={{ mt: 3 }}>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Data Inicial"
                name="date_from"
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Data Final"
                name="date_to"
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  </Box>
);

SalesListToolbar.propTypes = {
  dateFrom: PropTypes.string,
  setDateFrom: PropTypes.func,
  dateTo: PropTypes.string,
  setDateTo: PropTypes.func,
  onRefresh: PropTypes.func
};

export default SalesListToolbar;
